import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';
import selectors from 'state/selectors';

import CommonButton from 'components/Buttons/CommonButton';

const EditCompany = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedCompany = useSelector(selectors.configurator.getSelectedCompany);

  return (
    <CommonButton
      id="edit-company"
      action={() => dispatch(actions.configurator.setFormModeCompany('edit'))}
      disabled={!selectedCompany || !utils.user.isActionByCompanyActive(actionType.EDIT_COMPANY, selectedCompany.name)}
      scope="tertiary"
      value={t('EditCompany')}
      customIcon="pen"
    />
  );
};

export default EditCompany;
